import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { selectLocalScreenshareBroadcasting } from 'features/streaming/streamingSlice';
import { selectMobileScreenshare } from 'features/sdk/sdkStateSlice';
import { call, select } from 'redux-saga/effects';
import { eventBus } from 'utils/eventBus';
import { validationMobileScreenshareDataSchema } from 'features/sdk/utils/schemas';
import { RTCClient } from 'utils/webrtc';
import { fromZodError } from 'zod-validation-error';
import type { MobileScreenshareData } from 'utils/eventBus';

export function* onStartMobileScreenshareCommandSaga(data: MobileScreenshareData) {
  const canScreenshare: boolean = yield call(hasPermissionsSaga, PermissionTypes.screenshare);

  if (!canScreenshare) {
    yield call(
      eventBus.forbiddenActionError,
      'Forbidden action. This participant is not allowed to screenshare',
      'screenshare'
    );

    return;
  }

  const mobileScreenshare: boolean = yield select(selectMobileScreenshare);

  if (!mobileScreenshare) {
    yield call(
      eventBus.notAllowedError,
      'Mobile screenshare is disabled. You’ll need to edit this room’s properties to enable it.',
      'screenshare'
    );

    return;
  }

  const validationData = validationMobileScreenshareDataSchema.safeParse(data);

  if (!validationData.success) {
    const validationError = fromZodError(validationData.error);

    yield call(eventBus.error, {
      name: 'mobile-screenshare',
      message: validationError.toString(),
    });

    return;
  }

  const isBroadcasting: boolean = yield select(selectLocalScreenshareBroadcasting);

  if (!isBroadcasting) {
    yield call(RTCClient.screensharingFeed.startMobileScreenshare, data);
  }
}
